import type { StaffOperationsData } from '../../types/plans'

export function StaffOperationsFeedSection({
  data,
  loading,
  error,
  activeSlug,
  onRetry,
}: {
  data: StaffOperationsData | null
  loading: boolean
  error: string | null
  activeSlug: string
  onRetry: () => void
}) {
  const panel = data?.panels.find((entry) => entry.slug === activeSlug) ?? null

  if (loading) {
    return <section className="rounded-[28px] border border-slate-200/70 bg-white p-6 shadow-[0_18px_42px_rgba(15,23,42,0.08)]">Загружаем operational panel...</section>
  }

  if (error) {
    return (
      <section className="rounded-[28px] border border-slate-200/70 bg-white p-6 shadow-[0_18px_42px_rgba(15,23,42,0.08)]">
        <p className="mb-3 text-sm leading-6 text-slate-500">{error}</p>
        <button type="button" className="rounded-[18px] border border-sky-100 bg-sky-50 px-4 py-3 text-sm font-medium text-sky-800 transition" onClick={onRetry}>
          Повторить
        </button>
      </section>
    )
  }

  if (!panel) {
    return (
      <section className="rounded-[28px] border border-slate-200/70 bg-white p-6 shadow-[0_18px_42px_rgba(15,23,42,0.08)]">
        <p className="text-sm leading-6 text-slate-500">Для этого operational раздела пока нет доступных данных.</p>
      </section>
    )
  }

  return (
    <section className="grid gap-4 rounded-[28px] border border-slate-200/70 bg-white p-6 shadow-[0_18px_42px_rgba(15,23,42,0.08)]">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="mb-2 text-xs font-bold uppercase tracking-[0.14em] text-sky-600">Operational panel</p>
          <h2 className="text-xl font-semibold text-slate-900">{panel.title}</h2>
          <p className="mt-1 text-sm leading-6 text-slate-500">{panel.summary}</p>
        </div>
      </div>
      <p className="text-sm leading-6 text-slate-500">{panel.description}</p>
      <div className="flex flex-wrap gap-3">
        {panel.metrics.map((metric) => (
          <article key={`${panel.slug}:${metric.label}`} className="grid gap-1 rounded-[20px] border border-slate-200/70 bg-white px-4 py-3 shadow-sm">
            <span className="text-[13px] text-slate-500">{metric.label}</span>
            <strong className="text-slate-900">{metric.value}</strong>
          </article>
        ))}
      </div>
      <div className="grid gap-4">
        {panel.items.map((item) => (
          <article key={item.id} className="flex flex-col gap-3 rounded-[20px] bg-slate-50 px-4 py-4 lg:flex-row lg:items-start lg:justify-between">
            <div>
              <strong className="text-slate-900">{item.title}</strong>
              {item.subtitle ? <p className="mt-1 text-sm leading-6 text-slate-500">{item.subtitle}</p> : null}
            </div>
            <div className="grid gap-1 lg:justify-items-end">
              {item.value ? <span className="font-medium text-slate-900">{item.value}</span> : null}
              {item.status ? <small className="text-xs uppercase tracking-[0.08em] text-slate-500">{item.status}</small> : null}
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}
